import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import { construireDonneesCommunes, estGenreFeminin } from '../construireDonneesCommunes.js';

const CHEMIN_TEMPLATE = '/templates/PVRI.docx';

function construireDonneesPVRI(formData, numDoc) {
  const {
    phases,
    livrables,
    phasesRealiseesIds,
    livrablesRemisIds,
  } = formData.commun;
  
  const accordRepute = estGenreFeminin(formData.commun.client.genre) ? 'est réputée' : 'est réputé';


  const phasesPVRI = phases
    .filter((phase) => phasesRealiseesIds.includes(phase.id))
    .map((phase, index) => ({
      numeroPhase: index + 1,
      designationPhase: phase.designation,
      nombreJehPhase: phase.nombreJeh,
      descriptionPhase: phase.description_phase,
    }));

  const livrablesPVRI = livrables
    .filter((livrable) => livrablesRemisIds.includes(livrable.id))
    .map((livrable) => ({
      nomLivrable: livrable.nom,
    }));

  const accordLesdits = livrablesPVRI.length > 1 ? 'lesdits' : 'ledit';
  const accordLivrables = livrablesPVRI.length > 1 ? 'livrables' : 'livrable';

  return {
    ...construireDonneesCommunes(formData, 'PVRI', numDoc),

    // Noms attendus par le template Word
    phases: phasesPVRI,
    livrables: livrablesPVRI,
    accordRepute,
    accordLesdits,
    accordLivrables,
  };
}

async function genererPVRI(formData, numDoc) {
  const reponse = await fetch(CHEMIN_TEMPLATE);

  if (!reponse.ok) {
    throw new Error(
      `Impossible de charger le template (${reponse.status})`
    );
  }

  const zip = new PizZip(await reponse.arrayBuffer());

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
  });

  const donnees = construireDonneesPVRI(formData, numDoc);

  try {
    doc.render(donnees);
  } catch (error) {
    console.error('Erreur de génération du PVRI :', error);

    if (error.properties?.errors) {
      console.error(
        JSON.stringify(error.properties.errors, null, 2)
      );
    }

    throw error;
  }

  const blob = doc.getZip().generate({
    type: 'blob',
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });

  saveAs(blob, `${donnees.refDocument}.docx`);
}

export default genererPVRI;